import { speed } from 'Lib/speed/speed';
import 'Vendor/owlcarousel/owl.carousel.min';
import './include/shop-filter';
import './include/map-shops';

// Слайдер в блоке Холдинг
const cSliderOn = 'owl-carousel';
const $holdingSlider = $('.about-company__holding-slider');

if ($holdingSlider.find('.about-company__holding-slider-item').length > 1) {
    $holdingSlider.each(function () {
        $(this).trigger('destroy.owl.carousel')
            .removeClass(cSliderOn)
            .addClass(cSliderOn)
            .owlCarousel({
                smartSpeed: speed,
                dots: false,
                navClass: ['about-company__holding-slider-prev arrow arrow_prev arrow_shadow', 'about-company__holding-slider-next arrow arrow_next arrow_shadow'],
                navText: ['', ''],
                responsive: {
                    0: { items: 1, slideBy: 1 },
                    620: { items: 2, slideBy: 2 },
                    770: { items: 2, slideBy: 2, nav: true },
                    880: { items: 2, slideBy: 2, nav: true },
                    1100: { items: 3, slideBy: 3, nav: true },
                },
            });
    });
}

$('.about-company__selectbox .selectbox__option').on('click', function () {
    const type = $(this).attr('data-value');

    $('.about-company__form-about').removeClass('about-company__form-about_active');

    if (type === 'Я — корпоративный клиент') {
        $('.about-company__form-about_corp-client').addClass('about-company__form-about_active');
    } else if (type === 'Я — оптовый клиент') {
        $('.about-company__form-about_opt-client').addClass('about-company__form-about_active');
    } else {
        $('.about-company__form-about_default').addClass('about-company__form-about_active');
    }
});